import React from "react"
import Layout from "../components/layout"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Grid from "@material-ui/core/Grid"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableRow from "@material-ui/core/TableRow"
import FormularioDeContacto from "../components/formulario-de-contacto"
import ninoyaxel from "../images/site/ninoyaxel.jpg"
import Spacer from "../components/spacer"

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  imageWrapper: {
    padding: 16,
    paddingTop: 40,
    opacity: 0.5,
    marginTop: 4,
  },
  dataWrapper: {
    marginTop: 48,
  },
  image: {
    borderRadius: 16,
    width: "100%",
    boxShadow: "2px 2px 2px #f0f0c0",
    border: "1px solid #f0f0f0",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    marginTop: 48,
  },
  table: {},
  quizas: {
    marginBottom:24,
  },
  textoWrapper: {
    padding: 16,
  },
  formWrapper: {
    padding: 16,
  },
}))

export default function Contacto({ data }) {
  const classes = useStyles()
  const handleClose = () => {}
  return (
    <Layout>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} className={classes.dataWrapper}>
          <Paper elevation={1}>
            <Grid container>
              <Grid item xs={4}>
                <div className={classes.imageWrapper}>
                  <img alt="" src={ninoyaxel} className={classes.image} />
                </div>
              </Grid>
              <Grid item xs={8}>
                <div className={classes.textoWrapper}>
                  <p>Siempre a su Servicio!</p>
                  <p>
                    En Fiammengo SRL buscamos brindarle el mejor servicio y
                    asesoramiento!!
                  </p>
                  <p>
                    Si desea obtener más información acerca de nuestros
                    productos o realizar alguna consulta no dude en
                    contactarnos.
                  </p>
                </div>
              </Grid>
            </Grid>
          </Paper>
          <Spacer pixels={24} />
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell>Dirección Postal</TableCell>
                  <TableCell>
                    Blanco Encalada 1190
                    <br />
                    C.P. (B1768BIP) Ciudad Madero
                    <br />
                    Provincia de Buenos Aires
                    <br />
                    República Argentina
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Teléfono/Fax</TableCell>
                  <TableCell>(+54 11) 4454-8343</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Dirección de e-mail</TableCell>
                  <TableCell>ventas@fiammengo.com.ar</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper} elevation={1}>
            <div className={classes.formWrapper}>
              <div className={classes.quizas}>
                O completando este formulario:
              </div>
              <FormularioDeContacto contactame handleClose={handleClose} />
            </div>
          </Paper>
        </Grid>
      </Grid>
    </Layout>
  )
}
